class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}

/*OCULTAR TAB SI ES QUE NO TIENE CONTENIDO*/

/*document.addEventListener("DOMContentLoaded", function() {
    // Obtenemos todos los tabs y sus contenidos correspondientes
    var tabs = document.querySelectorAll('.m-tabs__header .m-tab-header');
    var contents = document.querySelectorAll('.m-tab-content__inner');

    if(tabs.length !== contents.length) {
        console.error('La cantidad de tabs y contenidos no coincide');
        return;
    }

    contents.forEach(function(content, index) {
        // Verificamos si el contenido está vacío
        if (!content.textContent.trim()) {
            // Si está vacío, ocultamos el tab correspondiente
            tabs[index].style.display = 'none';
        }
    });
});*/

/*document.addEventListener("DOMContentLoaded", function() {
    // Obtenemos todos los tabs y sus contenidos correspondientes
    var tabs = document.querySelectorAll('.m-tabs__header .m-tab-header');
    var contents = document.querySelectorAll('.m-tab-content__inner');

    if (tabs.length !== contents.length) {
        console.error('La cantidad de tabs y contenidos no coincide');
        return;
    }

    tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
            // Quitamos la clase "active" de todos los tabs
            tabs.forEach(function(t) {
                t.classList.remove('active');
            });

            // Añadimos la clase "active" al tab clickeado
            tab.classList.add('active');

            // Ocultamos el contenido de todos los tabs
            contents.forEach(function(content) {
                content.style.display = 'none';
            });

            // Mostramos el contenido correspondiente al tab clickeado
            contents[index].style.display = 'block';
        });
    });

    // Verificamos si el contenido del tab inicial está vacío
    var initialIndex = 0; // Puedes ajustar este índice según el tab que desees como inicial

    if (!contents[initialIndex].textContent.trim()) {
        // Quitamos la clase "active" y ocultamos el tab correspondiente si el contenido está vacío
        tabs[initialIndex].classList.remove('active');
        tabs[initialIndex].style.display = 'none';

        // Pasamos la clase "active" al siguiente tab
        var nextIndex = (initialIndex + 1) % tabs.length; // Circular para evitar índices fuera de rango
        tabs[nextIndex].classList.add('active');
    }
});*/

document.addEventListener("DOMContentLoaded", function () {
    var tabs = document.querySelectorAll('.m-tabs__header .m-tab-header');
    var accordionItems = document.querySelectorAll('.m-tabs__content .m-accordion--item');

    if (tabs.length !== accordionItems.length) {
        console.error('La cantidad de tabs y accordionItems no coincide');
        return;
    }

    function activateTab(index) {
        // Quitamos la clase "active" de todos los tabs y accordionItems
        tabs.forEach(function (t) {
            t.classList.remove('active');
        });

        accordionItems.forEach(function (item) {
            item.classList.remove('active');
            item.style.display = 'none';
        });

        // Añadimos la clase "active" al tab y accordionItem correspondiente
        tabs[index].classList.add('active');
        accordionItems[index].classList.add('active');
        accordionItems[index].style.display = 'block';
    }

    tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activateTab(index);
        });
    });

    // Verificamos si el contenido del tab inicial está vacío
    var initialIndex = 0;

    if (!accordionItems[initialIndex].querySelector('.m-tab-content__inner').textContent.trim()) {
        // Quitamos la clase "active" y ocultamos el tab y accordionItem correspondiente
        tabs[initialIndex].classList.remove('active');
        tabs[initialIndex].style.display = 'none';

        accordionItems[initialIndex].classList.remove('active');
        accordionItems[initialIndex].style.display = 'none';

        // Pasamos la clase "active" al siguiente tab y accordionItem
        var nextIndex = (initialIndex + 1) % tabs.length;
        activateTab(nextIndex);
    }
});





